import { DatepickerLocale } from '@bbraun/cortex-web';

export const getLocaleData = (locale: string): DatepickerLocale | null => {
  if (!locale || !localeMap[locale]) {
    return null;
  }
  return localeMap[locale];
};

const localeMap: { [key: string]: DatepickerLocale & { dateFormat: string } } = {
  en: {
    weekdays: {
      shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    },
    months: {
      shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      longhand: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    },
    firstDayOfWeek: 0,
    rangeSeparator: ' — ',
    amPM: ['AM', 'PM'],
    time24hr: true,
    dateFormat: 'MM/DD/YYYY'
  },
  de: {
    weekdays: {
      shorthand: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      longhand: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
    },
    months: {
      shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      longhand: [
        'Januar',
        'Februar',
        'Maerz',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
      ]
    },
    firstDayOfWeek: 1,
    rangeSeparator: ' — ',
    amPM: ['AM', 'PM'],
    time24hr: true,
    dateFormat: 'DD.MM.YYYY'
  }
};
